export const ATTEMPT_STORAGE_KEY = 'digitiles.challenge-attempts.v1';

/** Add no eager catalog dependency to Home; skip definition parsing without a
 * book. Existing books pass the authoritative schema before classification. */
export async function readAttemptProjectReferences(): Promise<
  readonly { project: string; mainChipId: string }[]
> {
  if (localStorage.getItem(ATTEMPT_STORAGE_KEY) === null) return [];
  const { readAttempts } = await import('./storage');
  return readAttempts();
}
